import TextField from 'components/form/Input';
import React, { useEffect, useState } from 'react';
import Button from 'components/common/Button';
import { Box, makeStyles } from '@material-ui/core';
import SocialBtns from './SocialBtns';
import {useSelector} from "react-redux";

const useStyles = makeStyles((theme) => ({
  input: {
    paddingLeft: theme.spacing(2),
    minWidth: theme.spacing(60),
  },
  toggle: {
    'color': theme.palette.primary.main,
    'border': 'none',
    '&.Mui-selected[aria-label="twitter"]': {
      color: '#1DA1F2',
      background: 'none',
    },
    '&.Mui-selected[aria-label="linkedin"]': {
      color: '#0077b5',
      background: 'none',
    },
    '&.Mui-selected[aria-label="facebook"]': {
      color: '#4267B2',
      background: 'none',
    },
  },
}));

const ShareInput = ({ value, onChange, ...props }) => {
  const user = useSelector((s) => s.user.user);
  const classes = useStyles();
  const [view, setView] = useState('twitter');
  const [url, setUrl] = useState(
    `https://twitter.com/intent/tweet?url=https://www.weadmit.com&text=${value}`,
  );

  useEffect(() => {
    if (!view) {
      setView('twitter');
    }
  }, [view]);

  useEffect(() => {
    handleUrlText(view)
  }, [value]);

  const handleUrlText = (val) => {
    switch (val) {
      case 'twitter':
        setUrl(
          `https://twitter.com/intent/tweet?url=https://www.weadmit.com&text=${value}`,
        );
        break;
      case 'linkedin':
        setUrl(
          `https://www.linkedin.com/shareArticle?mini=true&url=https://www.weadmit.com`,
        );
        break;
      case 'facebook':
        setUrl(
          `https://www.facebook.com/sharer/sharer.php?u=https://www.weadmit.com&quote=${value}`,
        );
        break;
      default:
        setUrl(
          `https://twitter.com/intent/tweet?url=https://www.weadmit.com&text=${value}`,
        );
    }
  }

  const handleChange = (e, val) => {
    setView(val);
    handleUrlText(val)
  };

  return (
    <Box display="flex" paddingTop={4}>
      <SocialBtns classes={classes} view={view} handleChange={handleChange} />
      <Box className={classes.input}>
        <TextField onChange={onChange} value={value} {...props} />
        <Box textAlign="center">
          <Button
            variant="contained"
            color="primary"
            target="_blank"
            href={url}
            onClick={() => {
              window.analytics.track(`Click: Social share`, {
                userId: user.id,
                channel: view
              })
            }}
          >
            Share on {view}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ShareInput;
